import type { CaseState } from "../types/caseState";
import type { SuggestedQuestion } from "../types/suggestquestions";
import { apiUrl } from "./base";

export type ContextSuggestionsResponse = {
  suggested_questions: SuggestedQuestion[];
};

export async function fetchContextSuggestions(input: {
  transcriptWindow: string;
  caseState: CaseState;
  askedQuestions: string[];
  dismissedQuestions: CaseState["dismissedQuestions"];
  contactType: string;
  includeAllTemplateFields?: boolean;
  sessionId?: string | null;
  signal?: AbortSignal;
}): Promise<ContextSuggestionsResponse> {
  const res = await fetch(apiUrl("/api/contextSuggestions"), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(input),
    signal: input.signal,
  });

  if (!res.ok) {
    throw new Error(await res.text());
  }

  return (await res.json()) as ContextSuggestionsResponse;
}

